import Image from 'next/image';

const LoadingSpinner = ({ number = 1 }) => {
  return (
    <div className="width-full flex items-center justify-center p-20">
      <Image
        src="/assets/images/DTS_Logo_3d_Spin.gif"
        width="130"
        height="44"
        alt="Loading...."
        priority
      />
    </div>
  );
};

export default LoadingSpinner;
